module.exports = __webpack_public_path__ + "img/bhszaldpp.30fc11ff.png";